import PtcIcon from '~/components/Atmos/PtcIcon/PtcIcon.vue';
<template>
  <li
    :class="{
      'grid border border-b border-www-color-neutral-light': true,
    }"
  >
    <button
      :class="{
        'flex items-start justify-between px-5 py-4': true,
      }"
      @click="open = !open"
    >
      <span
        :class="{
          'text-start font-bold text-www-color-neutral-medium-dark': true,
        }"
      >
        {{ label }}
      </span>

      <div
        :class="{
          'flex aspect-square transition-transform duration-300 ease-in-out': true,
          'rotate-180': open,
        }"
      >
        <PtcIcon
          name="ptc-pricing-accordion-chevron"
          :class="{
            'text-25px leading-4': true,
          }"
          alt="ptc-pricing-accordion-chevron"
        />
      </div>
    </button>

    <div
      v-if="open"
      :class="{
        'border-t border-www-color-neutral-light bg-www-color-neutral-off-white p-4': true,
      }"
    >
      <slot />
    </div>
  </li>
</template>

<script lang="ts" setup>
import PtcIcon from '~/components/Atmos/PtcIcon/PtcIcon.vue';
defineProps<{
  label: string;
}>();

const open = ref(false);
</script>
